import { render } from "./verify-account.vue?vue&type=template&id=44ff4d6a&scoped=true"
import script from "./verify-account.vue?vue&type=script&lang=js"
export * from "./verify-account.vue?vue&type=script&lang=js"

import "./verify-account.vue?vue&type=style&index=0&id=44ff4d6a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44ff4d6a"]])

export default __exports__